import { Model, MapTo } from 'src/app/decorators/mapto';

import { SettingBaseDataModel } from './settings-base-data.model';

export class SettingBaseModel extends Model {
    @MapTo()
    is_enable: number;
    @MapTo()
    unit: string;
    @MapTo()
    data: SettingBaseDataModel;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
